<template>
  <v-app>
    <div id="app" class="wrapper">
      <div v-if="!show">
        <NavBar />
        <AsideBar />
      </div>
      <Navigation v-else-if="show" />
      <router-view></router-view>
    </div>
  </v-app>
</template>
<script>
import Navigation from "./components/Navigation.vue";
import NavBar from "./components/mainDash/NavBar.vue";
import AsideBar from "./components/mainDash/AsideBar.vue";

export default {
  name: "App",
  components: {
    Navigation,
    NavBar,
    AsideBar,
  },
  data() {
    return {
      isLoggedin: false,
      show: true,
      domains: [],
      domainId: this.$route.params.id,
      isCollapsedAsideBar: false,
    };
  },
  beforeMount() {
    setTimeout(() => {
      let activeLink = document.querySelector(
        ".dropdown-item.router-link-exact-active.router-link-active"
      );

      if (activeLink)
        document.getElementById("dropdownMenuLink").textContent =
          activeLink.innerHTML;
    }, 2000);
  },
  beforeMount() {
    sessionStorage.setItem("isCollapsedAsideBar", true);
  },
  mounted() {
    this.$route.name == "Register" ||
    this.$route.name == "Login" ||
    this.$route.name == "Home" ||
    this.$route.name == "Page Not Found"
      ? (this.show = true)
      : (this.show = false);

    if (
      this.$route.name == "NewWebsite" ||
      this.$route.name == "Page Not Found"
    ) {
      document.getElementsByTagName("nav")[0].style.display = "none";
      document.getElementsByTagName("aside")[0].style.display = "none";
    }

    document.getElementsByTagName("body")[0].classList.add("sidebar-mini");
    document.getElementsByTagName("body")[0].classList.add("layout-fixed");

    setTimeout(() => {
      if (this.$route.params.id && document.getElementById("dropdownMenuLink"))
        document.getElementById("dropdownMenuLink").innerText =
          document.getElementById(this.$route.params.id).innerText;
    }, 7000);
  },
  // methods: {
  //   isSidebarCollapsed() {
  //     return document
  //       .querySelector("body")
  //       .classList.contains("sidebar-collapse");
  //   },
  // },
  watch: {
    $route(to, from) {
      to.name == "Register" ||
      to.name == "Login" ||
      to.name == "Home" ||
      to.name == "Page Not Found"
        ? (this.show = true)
        : (this.show = false);

      if (
        sessionStorage.length &&
        (from.name === null ||
          (from.params.id !== undefined && from.params.id !== to.params.id))
      ) {
        sessionStorage.removeItem("pageLength");
        sessionStorage.removeItem("pageNumber");
      }
    },
    "$route.params.id"() {
      setTimeout(function () {
        let activeLink = document.querySelector(
          ".dropdown-item.router-link-exact-active.router-link-active"
        );

        if (activeLink)
          document.getElementById("dropdownMenuLink").innerHTML =
            activeLink.innerHTML;
      }, 1000);
    },
  },
};
</script>

<style>
#app {
  overflow: hidden;
  height: fit-content;
}
.btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
.btn-group > .btn-group:not(:first-child) > .btn,
.btn-group > .btn:not(:first-child) {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
/* .v-application {
  height: 0px !important;
} */
.hide-scrollbar {
  -ms-overflow-style: none; /* IE 11 */
  scrollbar-width: none; /* Firefox 64 */
}
.breadcrumb-item {
  cursor: pointer !important;
}
label {
  width: fit-content !important;
}
.v-treeview-node__root {
  background: #fff !important;
}
#dropdownMenuButton,
button:not(.v-btn):not(.btn-light):not(.button--round-l):not(.mx-btn):not(
    .swal2-cancel
  ):not(.v-icon) {
  color: #fff;
}
.swal2-cancel {
  color: #414141 !important;
}
select::-webkit-scrollbar {
  display: none !important;
}
select::-moz-scrollbar {
  display: none !important;
}
select::-o-scrollbar {
  display: none !important;
}
select::-ms- {
  display: none !important;
}
</style>
